// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"CampaignDeliverablesReview_buttonWrapper__2OLGu"};